module.exports = __webpack_public_path__ + "img/shakhands.e5afcf25.png";